export default __webpack_public_path__ + "static/6647-007cf4fd6b273131bacc0f6f6d54f064.jpg";